module.exports = __webpack_public_path__ + "media/components/country-flag/static/ly-ce844751d662245e205b1cfab9dec085.svg";